import { Switch as AntdSwitch } from 'antd';

export default AntdSwitch;
